import { ImageLinkData } from '../../../Content';
import { useScene } from '../../../contexts/SceneContext';

interface ImageLinkContentProps {
  content: ImageLinkData;
}

export const ImageLinkContent: React.FC<ImageLinkContentProps> = ({
  content,
}) => {
  const { parseContentPath } = useScene();

  return (
    <a href={content.href} target="_blank" rel="noreferrer">
      <img
        alt={content.title}
        style={{
          width: '100%',
          height: 'auto',
          margin: 0,
        }}
        src={parseContentPath(content.src)}
      />
    </a>
  );
};
